module.exports = __webpack_public_path__ + "img/logo-csr.bc645c70.svg";